import Home from '../pages/Home.vue'
import Login from '../pages/Login.vue'
import Purchases from '../pages/Purchases.vue'
import PurchaseSimulation from '../pages/PurchaseSimulation.vue'
import Receiving from '../pages/Receiving.vue'
import Sales from '../pages/Sales.vue'
import ProductionJournals from '../pages/ProductionJournals.vue'
import MaterialJournals from '../pages/MaterialJournals.vue'
import Inventory from '../pages/Inventory.vue'
import Statistics from '../pages/Statistics.vue'
import Accounts from '../pages/accounts/Accounts.vue'
import Account from '../pages/accounts/Account.vue'
import Items from '../pages/items/Items.vue'
import Item from '../pages/items/Item.vue'
import ItemsStatement from '../pages/items/ItemsStatement.vue'
import RolesManagement from '../pages/settings/roles-management/RolesManagement.vue'
import Role from '../pages/settings/roles-management/Role.vue'
import GeneralSettings from '../pages/settings/GeneralSettings.vue'
import MaterialSimulation from '../pages/simulationMaterial/MaterialSimulation.vue'
import FiscalYears from '../pages/settings/FiscalYears.vue'
import ComparePage from '../pages/ComparePage.vue'
import MaterialSimulationCardamom from '../pages/simulationMaterial/MaterialSimulationCardamom.vue'
import TabSimulationMaterial from '../pages/simulationMaterial/TabSimulationMaterial.vue'

export default [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: {
			i18nTranslateKey: 'home'
		}
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			i18nTranslateKey: 'login'
		}
	},
	{
		path: '/offers',
		name: 'purchases',
		component: Purchases,
		meta: {
			i18nTranslateKey: 'purchases'
		}
	},
	{
		path: '/offer-simulation/:id',
		name: 'purchase-simulation',
		component: PurchaseSimulation,
		meta: {
			i18nTranslateKey: 'purchase-simulation'
		}
	},
	{
		path: '/experimental-simulation',
		name: 'experimental-simulation',
		component: PurchaseSimulation,
		meta: {
			i18nTranslateKey: 'experimental-simulation'
		}
	},
	{
		path: '/purchases',
		name: 'receiving',
		component: Receiving,
		meta: {
			i18nTranslateKey: 'receiving'
		}
	},
	{
		path: '/sales',
		name: 'sales',
		component: Sales,
		meta: {
			i18nTranslateKey: 'sales'
		}
	},
	{
		path: '/production-orders',
		name: 'production-orders',
		component: ProductionJournals,
		meta: {
			i18nTranslateKey: 'production-orders'
		}
	},
	{
		path: '/order-results',
		name: 'order-results',
		component: ProductionJournals,
		meta: {
			i18nTranslateKey: 'order-results'
		}
	},
	{
		path: '/material-journals/:id?',
		name: 'material-journals',
		component: MaterialJournals,
		meta: {
			i18nTranslateKey: 'material-journals'
		}
	},
	{
		path: '/receiving-journals/:id?',
		name: 'receiving-journals',
		component: MaterialJournals,
		meta: {
			i18nTranslateKey: 'receiving-journals'
		}
	},
	{
		path: '/raw-cardamom-sorting-journals/:id?',
		name: 'raw-cardamom-sorting-journals',
		component: MaterialJournals,
		meta: {
			i18nTranslateKey: 'raw-cardamom-sorting-journals'
		}
	},
	{
		path: '/cardamom-sorting-journals/:id?',
		name: 'cardamom-sorting-journals',
		component: MaterialJournals,
		meta: {
			i18nTranslateKey: 'cardamom-sorting-journals'
		}
	},
	{
		path: '/delivery-journals/:id?',
		name: 'delivery-journals',
		component: MaterialJournals,
		meta: {
			i18nTranslateKey: 'delivery-journals'
		}
	},
	{
		path: '/inventory',
		name: 'inventory',
		component: Inventory,
		meta: {
			i18nTranslateKey: 'inventory'
		}
	},
	{
		path: '/items-statement',
		name: 'items-statement',
		component: ItemsStatement,
		meta: {
			i18nTranslateKey: 'items-statement'
		}
	},
	{
		path: '/statistics',
		name: 'statistics',
		component: Statistics,
		meta: {
			i18nTranslateKey: 'statistics'
		}
	},
	{
		path: '/accounts',
		name: 'accounts',
		component: Accounts,
		meta: {
			i18nTranslateKey: 'accounts'
		},
		children: [
			{
				path: '/account/:id?',
				name: 'account',
				component: Account,
				meta: {
					i18nTranslateKey: 'account'
				},
			}
		]
	},
	{
		path: '/general-settings',
		name: 'general-settings',
		component: GeneralSettings,
		meta: {
			i18nTranslateKey: 'general-settings'
		}
	},
	{
		path: '/items',
		name: 'items',
		component: Items,
		meta: {
			i18nTranslateKey: 'items'
		},
		children: [
			{
				path: '/item/:id?',
				name: 'item',
				component: Item,
				meta: {
					i18nTranslateKey: 'item'
				},
			}
		]
	},
	{
		path: '/roles-management',
		name: 'roles-management',
		component: RolesManagement,
		meta: {
			i18nTranslateKey: 'roles-management'
		},
		children: [
			{
				path: '/roles/:id?',
				name: 'role',
				component: Role,
				meta: {
					i18nTranslateKey: 'role'
				},
			}
		]
	},
	
	{
		path: '/fiscal-years',
		name: 'fiscal-years',
		component: FiscalYears,
		meta: {
			i18nTranslateKey: 'fiscal-years'
		}
	},
	{
		path: '/compare/:id?',
		name: 'compare',
		component: ComparePage,
		meta: {
			i18nTranslateKey: 'compare'
		}	
	},
	
	{
		path: '/simulation-material',
		name: 'simulation-material',
		component: TabSimulationMaterial,
		meta: {
			i18nTranslateKey: 'material-simulation'
		},
		children: [
			{
				path: '/simulation-material/cardamom',
				name: 'material-simulation-cardamom',
				component: MaterialSimulationCardamom,
				meta: {
					i18nTranslateKey: 'material-simulation'
				}
			},
			{
				path: '/simulation-material/material-simulation',
				name: 'material-simulation',
				component: MaterialSimulation,
				meta: {
					i18nTranslateKey: 'material-simulation'
				}
			}
		]
	},
	
	{
		path: '*',
		redirect: '/'
	}
]